import AssignmentReturnIcon from "@material-ui/icons/AssignmentReturn";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import SentimentSatisfiedIcon from "@material-ui/icons/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@material-ui/icons/SentimentSatisfiedAlt";
import SentimentVerySatisfiedIcon from "@material-ui/icons/SentimentVerySatisfied";
import React from "react";
import Cancel from "./Icons/Cancel";
import Mood from "./Icons/Mood";
import Schedule from "./Icons/Schedule";
import SentimentBad from "./Icons/SentimentBad";
import SentimentNeutral from "./Icons/SentimentNeutral";
import { colors } from "./tokens";

export const getSummaryIcons = (status) => {
	const fixedIcons = {
		confirmationTime: { icon: Schedule },
		refusalRate: { icon: Cancel },
	};

	if (status === "success") {
		return { onTime: { icon: Mood }, ...fixedIcons };
	}

	if (status === "warning") {
		return {
			onTime: { icon: SentimentNeutral },
			...fixedIcons,
		};
	}

	return { onTime: { icon: SentimentBad }, ...fixedIcons };
};

export const statusIcons = {
	info: { icon: AutorenewIcon, color: colors.picking },
	error: { icon: AssignmentReturnIcon, color: colors.returning },
};

export const statusRoutes = {
	info: "/picking",
	error: "/returning-to-storage",
};

export const tableDetailPages = {
	expiring: "new-orders",
	overdue: "new-orders",
	withdrawal: "ready-to-go",
};

export const tableEmptyStates = {
	expiring: {
		title: "Nenhum pedido próximo do vencimento",
		description: "Nenhum pedido aguardando confirmação.",
		icon: SentimentSatisfiedIcon,
	},
	overdue: {
		title: "Todas as confirmações estão dentro do prazo",
		description: "Nenhum pedido aguardando confirmação.",
		icon: SentimentSatisfiedAltIcon,
	},
	withdrawal: {
		title: "Todas as retiradas estão dentro do prazo",
		description:
			"Nenhum pedido aguardando coleta ou cancelamento por ausência de retirada.",
		icon: SentimentVerySatisfiedIcon,
	},
};
